import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import ViewStandarCpuRam from "layouts/ec2disponibilidad/componentes/ViewEchartApacheFull";
import UtilModal from "verticales/UtilModal";
import ViewProcesos from "../ViewProcesos";
import MDBox from "components/MDBox";
import Modal from "@mui/material/Modal";

const InformesCards = (props) => {
  const [dataGrafico, setDataGrafico] = useState([]);
  const [timeIni, setTimeIni] = useState();
  const [openModal, setOpenModal] = React.useState(false);
  const [timeFin, setTimeFin] = useState();
  const [instanceId, setInstanceId] = useState();
  const [result, setResult] = useState({});
  const [open, setOpen] = useState(true); // Estado para controlar el modal
  const [selectedCardData, setSelectedCardData] = useState(null);

  useEffect(() => {
    console.log("Impresion InformesCards...", props.data);
    const data = props.data.arrVectores;
    const { arrVectores } = props.data;
    const valueInstanceId = props.data.arrVectores[0].metricas[0].instance_id;
    const valueAvgCpu = props.data.rows[0].avgCpu.toFixed(2);
    const valueAvgRam = props.data.rows[0].avgRam.toFixed(2);

    const transformedResult = {};

    arrVectores.forEach((item, index) => {
      const dataTransformada = item.metricas.map((key) => ({
        time: key.time / 1000,
        value: key.cpu_max,
        valueRam: key.ram_max,
      }));

      /*Conversión de Fechas a formato válido*/
      // console.log(`fecha Inicio: ${item.timeIni}`, typeof item.timeIni);
      const dataConvertIni = parseInt(item.timeIni);
      const dataTimeIni = new Date(dataConvertIni);
      const dataShowTimeIni = dataTimeIni.toLocaleString();

      const dataConvertFin = parseInt(item.timeFin);
      const dataTimeFin = new Date(dataConvertFin);
      const dataShowTimeFin = dataTimeFin.toLocaleString();
      // console.log(`fecha Fin: ${item.timeFin}`, typeof item.timeFin);
      /*Conversión de Fechas a formato válido*/

      transformedResult[`arreglo${index + 1}`] = {
        data: dataTransformada,
        instanceId: valueInstanceId,
        timeIni: dataShowTimeIni,
        timeFin: dataShowTimeFin,
        timeIniFetch: item.timeIni,
        timeFinFetch: item.timeFin,
      };
    });

    setResult(transformedResult);
    setTimeIni(timeIni);
    setTimeFin(timeFin);
    setInstanceId(valueInstanceId);
  }, [props.data]);

  // Función para abrir el modal
  const handleOpenModal = (cardData) => {
    setSelectedCardData(cardData);
    setOpenModal(true);
  };

  // Función para cerrar el modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const renderView = () => {
    return (
      <ViewProcesos
        handleCloseModal={handleCloseModal}
        instanceId={selectedCardData?.instanceId}
        timeIni={selectedCardData?.timeIniFetch}
        timeFin={selectedCardData?.timeFinFetch}
      />
    );
  };

  const renderCards = () => (
    <Grid container spacing={2}>
      {Object.keys(result).map((key) => {
        const cardData = result[key];
        console.log("Card Data...", cardData);

        const hasHighMetric = cardData.data.some(
          (metric) => metric.value > 90 || metric.valueRam > 90
        );
        return (
          <Grid item xs={12} sm={6} key={key}>
            {" "}
            <Card
              sx={{
                backgroundColor: hasHighMetric ? "#ffe7e3" : "white",
                mx: "auto",
                maxWidth: "100%",
                maxHeight: "max-content",
                margin: 1,
                padding: 2,
                overflow: "auto",
                border: "1px solid #dfdfdf",
              }}
            >
              <MDTypography variant="h6">Card {cardData.instanceId}</MDTypography>
              <MDTypography variant="h6">Tiempo Inicial:</MDTypography>
              <MDTypography variant="body2">{cardData.timeIni}</MDTypography>
              <MDTypography variant="h6">Tiempo Final:</MDTypography>
              <MDTypography variant="body2">{cardData.timeFin}</MDTypography>
              <ViewStandarCpuRam data={cardData.data} dataDisponibilidad={100} />
              <MDButton
                onClick={() => handleOpenModal(cardData)}
                component="a"
                target="_blank"
                rel="noreferrer"
                variant="outlined"
                size="small"
              >
                <MDTypography variant="h6" textTransform="capitalize" sx={{ whiteSpace: "pre" }}>
                  Ver Procesos
                </MDTypography>
              </MDButton>
            </Card>
          </Grid>
        );
      })}

      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderView}
      />
    </Grid>
  );

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  return (
    <Grid container spacing={1} mt={1}>
      <Grid container spacing={0} justifyContent="center">
        {/* <MDButton variant="contained" color="primary" onClick={handleOpen}>
          Abrir Modal
        </MDButton> */}
        <Modal
          open={open} // Controlado por el estado `open`
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-end",
          }}
        >
          <Card
            sx={{
              marginTop: "20px",
              width: "86%",
              height: "90%",
              maxHeight: "100vh",
              overflowY: "auto",
              boxShadow: 24,
            }}
          >
            {renderCards()}
          </Card>
        </Modal>
      </Grid>
    </Grid>
  );
};

InformesCards.propTypes = {
  data: PropTypes.shape({
    arrVectores: PropTypes.arrayOf(
      PropTypes.shape({
        metricas: PropTypes.arrayOf(
          PropTypes.shape({
            time: PropTypes.string.isRequired,
            cpu_max: PropTypes.number.isRequired,
            ram_max: PropTypes.number.isRequired,
            instance_id: PropTypes.string.isRequired,
          }).isRequired
        ).isRequired,
      }).isRequired
    ).isRequired,
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        avgCpu: PropTypes.number.isRequired,
        avgRam: PropTypes.number.isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,
};

export default InformesCards;
